import { render, staticRenderFns } from "./SingleFormat.vue?vue&type=template&id=6734bc3b"
import script from "./SingleFormat.vue?vue&type=script&lang=js"
export * from "./SingleFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports